const SvgBotIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 21 21" {...props}>
    <path
      fill="#fff"
      d="M17.925 9.656V7.202a1.65 1.65 0 0 0-1.65-1.65h-4.95V4.47a1.23 1.23 0 0 0 .05-1.791 1.238 1.238 0 0 0-2.113.875c0 .365.16.69.413.916v1.082h-4.95a1.65 1.65 0 0 0-1.65 1.65v2.473l-.06.005a.824.824 0 0 0-.765.822v1.65a.825.825 0 0 0 .825.825v4.125a1.65 1.65 0 0 0 1.65 1.65h11.55a1.65 1.65 0 0 0 1.65-1.65v-4.125a.825.825 0 0 0 .825-.825v-1.599a.8.8 0 0 0-.06-.375c-.167-.403-.524-.5-.766-.522m-11.55.846c0-.91.554-1.65 1.237-1.65s1.238.74 1.238 1.65-.555 1.65-1.238 1.65-1.237-.74-1.237-1.65m7.423 4.95c-.826-.002-6.598 0-6.598 0v-1.65s5.775-.002 6.601 0zm-.411-3.3c-.683 0-1.238-.74-1.238-1.65s.555-1.65 1.238-1.65 1.237.74 1.237 1.65-.554 1.65-1.237 1.65"
    />
  </svg>
);

export default SvgBotIcon;
